/* eslint-disable */
// @ts-nocheck

import React from "react";
import { PasswordInput, FormLabel } from "@carbon/react";
import FieldTooltip from "../tooltip/Tooltip";

interface IProps {
  id?: string;
  labelText: string;
  placeholder?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  value?: string;
  invalid?: boolean;
  invalidText?: string;
  tooltipText?: string;
  required?: boolean;
}

const PasswordField = ({
  id,
  labelText,
  placeholder,
  disabled = false,
  onChange,
  value,
  invalid = false,
  invalidText,
  tooltipText,
  required,
}: IProps) => {
  return (
    <div className="form-wrapper">
      <div className="form-label" data-cy="textFieldForm">
        <FormLabel data-cy={`${labelText.replaceAll(" ", "")}-textlabel`}>
          {labelText} {required === true ? "*" : null}
        </FormLabel>
      </div>

      <PasswordInput
        id={id}
        labelText=""
        onChange={(event: { target: { value: string } }) => {
          onChange(event.target.value);
        }}
        placeholder={placeholder || labelText}
        value={value}
        disabled={disabled}
        invalid={invalid}
        invalidText={invalidText}
        required={required}
        data-cy={`${labelText.replaceAll(" ", "")}-input`}
        onTogglePasswordVisibility
      />
    </div>
  );
};

export default PasswordField;
